// extracted by mini-css-extract-plugin
module.exports = {"sent":"GiftcardsTable_sent__1bX_v","link":"GiftcardsTable_link__2bcWw"};